// extracted by mini-css-extract-plugin
export default {"minor-home-banner":"styles_minor-home-banner__DbjGI","minor-banner-image":"styles_minor-banner-image__9Sgnt","minor-banner-text":"styles_minor-banner-text__lCCCu"};